import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const wa = (msg: string) =>
    window.open(`https://wa.me/5512987047332?text=${encodeURIComponent(msg)}`, '_blank');
  const goSection = (section: string) => {
    navigate('/');
    window.setTimeout(() => document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' }), 80);
  };

  const columns = [
    {
      title: 'Serviços',
      links: [
        { label: 'Desenvolvimento de Software', action: () => goSection('servicos') },
        { label: 'Inteligência Artificial', action: () => goSection('servicos') },
        { label: 'Infraestrutura', action: () => goSection('servicos') },
        { label: 'Produto & Design', action: () => goSection('servicos') },
        { label: 'Manutenção & Suporte', action: () => goSection('servicos') },
        { label: 'Outsourcing & Consultoria', action: () => goSection('servicos') },
      ],
    },
    {
      title: 'Soluções',
      links: [
        { label: 'Parcelex', action: () => goSection('solucoes') },
        { label: 'Sercred', action: () => goSection('solucoes') },
        { label: 'Agentes de IA', action: () => goSection('solucoes') },
        { label: 'Sistemas sob medida', action: () => goSection('servicos') },
        { label: 'Automações comerciais', action: () => goSection('servicos') },
      ],
    },
    {
      title: 'Ferramentas',
      links: [
        { label: 'Prospecção ativa', action: () => navigate('/prospeccao') },
        { label: 'Diagnóstico digital', action: () => wa('Olá, quero fazer um diagnóstico digital da minha empresa.') },
        { label: 'Cálculo de ROI', action: () => wa('Olá, quero calcular o ROI de um projeto de software.') },
      ],
    },
    {
      title: 'Empresa',
      links: [
        { label: 'Sobre nós', action: () => goSection('resultados') },
        { label: 'Entre em contato', action: () => goSection('contato') },
        { label: 'Seja nosso parceiro', action: () => wa('Olá, quero conversar sobre parceria com a MainCode.') },
        { label: 'Seja um investidor', action: () => wa('Olá, gostaria de saber mais sobre investimentos!') },
        { label: 'Trabalhe conosco', action: () => wa('Olá, quero fazer parte da equipe MainCode!') },
        { label: 'Política de Privacidade', action: () => wa('Olá, quero falar sobre política de privacidade da MainCode.') },
      ],
    },
  ];

  return (
    <footer className="w-full bg-gray-950 text-gray-400">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <button onClick={() => navigate('/')}>
              <img src="Logo_Horiz_Cor_Branc_Maincode.svg" alt="MainCode" className="h-12 mb-4" />
            </button>
            <p className="text-sm leading-relaxed mb-6">
              Software house especializada em desenvolvimento de sistemas, produtos digitais e infraestrutura para empresas que querem crescer.
            </p>
            <div className="flex gap-3">
              <a target="_blank" href="https://www.instagram.com/maincode_software?igsh=Z3U4dmFkMWsxcG9l" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/5 hover:bg-purple-600/20 border border-white/10 hover:border-purple-500/40 rounded-lg flex items-center justify-center transition-all">
                <img src="insta_icon.svg" alt="Instagram" className="w-4 h-4" />
              </a>
              <a target="_blank" href="https://www.linkedin.com/company/maincode-software/?viewAsMember=true" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/5 hover:bg-purple-600/20 border border-white/10 hover:border-purple-500/40 rounded-lg flex items-center justify-center transition-all">
                <img src="in_icon.svg" alt="LinkedIn" className="w-4 h-4" />
              </a>
              <a target="_blank" href="https://web.facebook.com/MainCode.Software" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/5 hover:bg-purple-600/20 border border-white/10 hover:border-purple-500/40 rounded-lg flex items-center justify-center transition-all">
                <img src="fb_icon.svg" alt="Facebook" className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Nav columns */}
          {columns.map(col => (
            <div key={col.title}>
              <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">{col.title}</h3>
              <ul className="space-y-2.5">
                {col.links.map(link => (
                  <li key={link.label}>
                    <button
                      onClick={link.action}
                      className="text-sm text-gray-400 hover:text-white transition-colors text-left"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact quick row */}
        <div className="mt-12 pt-8 border-t border-white/5 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-green-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </div>
            <div>
              <p className="text-xs text-gray-500">WhatsApp Comercial</p>
              <a href="https://wa.me/5512987047332" target="_blank" rel="noopener noreferrer" className="text-sm text-white hover:text-purple-300 transition-colors font-medium">(12) 98704-7332</a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-purple-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <p className="text-xs text-gray-500">E-mail Comercial</p>
              <a href="mailto:comercial@maincode.dev" className="text-sm text-white hover:text-purple-300 transition-colors font-medium">comercial@maincode.dev</a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-blue-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <p className="text-xs text-gray-500">Localização</p>
              <p className="text-sm text-white font-medium">São José dos Campos, SP</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-600">
          <p>© 2025 Maincode Software Ltda. — CNPJ 47.523.561/0001-39</p>
          <div className="flex gap-4">
            <button onClick={() => wa('Olá, quero falar sobre política de privacidade da MainCode.')} className="hover:text-gray-400 transition-colors">Política de Privacidade</button>
            <button onClick={() => wa('Olá, quero falar sobre termos de uso da MainCode.')} className="hover:text-gray-400 transition-colors">Termos de Uso</button>
            <button onClick={() => goSection('contato')} className="hover:text-gray-400 transition-colors">Ajuda</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
